import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/Icon_Shapes.png'
import _imports_1 from '../assets/Screenshot_Shapes_1.webp'
import _imports_2 from '../assets/Screenshot_Shapes_2.webp'
import _imports_3 from '../assets/Screenshot_Shapes_3.webp'
import _imports_4 from '../assets/Screenshot_Shapes_4.webp'
import _imports_5 from '../assets/Screenshot_Shapes_5.webp'
import _imports_6 from '../assets/Screenshot_Shapes_6.webp'
import _imports_7 from '../assets/Screenshot_Shapes_7.webp'
import _imports_8 from '../assets/Screenshot_Shapes_8.webp'


const _withScopeId = n => (_pushScopeId("data-v-79bb3098"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "icon"
}, null, -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "size-appname",
  style: {"padding":"0px","margin":"0px"}
}, [
  /*#__PURE__*/_createElementVNode("strong", null, "Shapes")
], -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "size-appname-icon" }, "version 1.0.5", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "Changelog - 1.0.5")
], -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("ul", null, [
  /*#__PURE__*/_createElementVNode("li", null, "Added a legacy icon"),
  /*#__PURE__*/_createElementVNode("li", null, "Changed the icon format to webp"),
  /*#__PURE__*/_createElementVNode("li", null, "Updated the about page")
], -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "Description")
], -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "Screenshots")
], -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "scrollScreenshots" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_1,
    class: "screenshot"
  }),
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_2,
    class: "screenshot"
  }),
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_3,
    class: "screenshot"
  }),
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_4,
    class: "screenshot"
  }),
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_5,
    class: "screenshot"
  }),
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_6,
    class: "screenshot"
  }),
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_7,
    class: "screenshot"
  }),
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_8,
    class: "screenshot"
  })
], -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "Links")
], -1))
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  href: "https://puffercat.gumroad.com/l/shapeswalls",
  class: ""
}, "Wallpapers", -1))
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  href: "mailto:puffercatt+shapes@gmail.com",
  class: ""
}, "E-mail", -1))
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  href: "https://cdn.puffercat.xyz/c/shapes/privacy",
  class: ""
}, "Privacy policy", -1))
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  href: "https://pufferrom.t.me",
  class: ""
}, "Telegram channel (releases)", -1))
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  href: "https://puffercatchannel.t.me",
  class: ""
}, "Telegram channel (general)", -1))
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  href: "https://puffercatrom.t.me",
  class: ""
}, "Support group", -1))
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  href: "https://github.com/KZacharski/shapes-wallpapers",
  class: ""
}, "GitHub repo", -1))
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_back_button = _resolveComponent("ion-back-button")!
  const _component_ion_buttons = _resolveComponent("ion-buttons")!
  const _component_ion_title = _resolveComponent("ion-title")!
  const _component_ion_toolbar = _resolveComponent("ion-toolbar")!
  const _component_ion_header = _resolveComponent("ion-header")!
  const _component_ion_col = _resolveComponent("ion-col")!
  const _component_ion_row = _resolveComponent("ion-row")!
  const _component_ion_column = _resolveComponent("ion-column")!
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_ion_grid = _resolveComponent("ion-grid")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_page = _resolveComponent("ion-page")!

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withCtx(() => [
      _createVNode(_component_ion_header, null, {
        default: _withCtx(() => [
          _createVNode(_component_ion_toolbar, null, {
            default: _withCtx(() => [
              _createVNode(_component_ion_buttons, { slot: "start" }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_back_button, { "default-href": "/" })
                ]),
                _: 1
              }),
              _createVNode(_component_ion_title, null, {
                default: _withCtx(() => [
                  _createTextVNode("Shapes")
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_ion_content, { fullscreen: true }, {
        default: _withCtx(() => [
          _createVNode(_component_ion_header, { collapse: "condense" }, {
            default: _withCtx(() => [
              _createVNode(_component_ion_toolbar, null, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_title, { size: "large" }, {
                    default: _withCtx(() => [
                      _createTextVNode("Shapes")
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_ion_grid, null, {
            default: _withCtx(() => [
              _createVNode(_component_ion_row, { class: "column-standard2" }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_col, { class: "bannerColumn" })
                ]),
                _: 1
              }),
              _createVNode(_component_ion_row, { class: "column-standard" }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_col, { size: "auto" }, {
                    default: _withCtx(() => [
                      _hoisted_1
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_ion_col, {
                    size: "auto",
                    class: "description-column"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_row, { style: {"padding":"0px","margin":"0px"} }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_column, { style: {"padding":"0px","margin":"0px"} }, {
                            default: _withCtx(() => [
                              _hoisted_2
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_ion_row, { style: {"padding":"0px"} }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_column, null, {
                            default: _withCtx(() => [
                              _hoisted_3
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_ion_row, { style: {"padding":"0px"} }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_column, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_icon, {
                                icon: _ctx.logoAndroid,
                                class: "size-appname-icon"
                              }, null, 8, ["icon"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_ion_row, { class: "column-standard2" }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_col, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_button, {
                        href: "https://cdn.puffercat.xyz/c/puffercat-apps/apks/Shapes/shapes-1.0.5.apk",
                        expand: "full",
                        shape: "round",
                        style: {"margin":"0px"},
                        download: "Shapes-latest.apk"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("Download")
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_ion_col, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_button, {
                        href: "https://play.google.com/store/apps/details?id=xyz.puffercat.shapes.android",
                        expand: "full",
                        shape: "round",
                        style: {"margin":"0px"}
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("Google Play")
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_ion_row, { class: "column-standard" }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_col, null, {
                    default: _withCtx(() => [
                      _hoisted_4,
                      _hoisted_5
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_ion_row, { class: "column-standard" }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_col, null, {
                    default: _withCtx(() => [
                      _hoisted_6,
                      _createTextVNode(" Shapes is a collection of monet-compliant wallpapers available in many colors"),
                      _hoisted_7,
                      _hoisted_8,
                      _createTextVNode(" • 3844x3844 resolution"),
                      _hoisted_9,
                      _createTextVNode(" • 4 categories: Blobs, Circles, Waves and Polygons"),
                      _hoisted_10,
                      _createTextVNode(" • Many colors: blue, emerald, gray, green, orange, pink, purple, red, teal, yellow"),
                      _hoisted_11,
                      _createTextVNode(" • Light and dark mode"),
                      _hoisted_12,
                      _createTextVNode(" • Open source app based on Frames"),
                      _hoisted_13,
                      _hoisted_14
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_ion_row, { class: "column-standard" }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_col, null, {
                    default: _withCtx(() => [
                      _hoisted_15,
                      _hoisted_16,
                      _hoisted_17
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_ion_row, { class: "column-standard" }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_col, null, {
                    default: _withCtx(() => [
                      _hoisted_18,
                      _hoisted_19,
                      _hoisted_20,
                      _hoisted_21,
                      _hoisted_22,
                      _hoisted_23,
                      _hoisted_24,
                      _hoisted_25,
                      _hoisted_26,
                      _hoisted_27,
                      _hoisted_28,
                      _hoisted_29,
                      _hoisted_30,
                      _hoisted_31,
                      _hoisted_32,
                      _hoisted_33
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}